import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import AppRouter from './Routers/AppRouter';
import configureStore from './Store/configureStore';
import registerServiceWorker from './registerServiceWorker';
import 'normalize.css/normalize.css';
import '@nike/ruxac/fonts';
import '@nike/ruxac/styles';
import './Styles/styles.scss';
import 'react-table/react-table.css';
const store = configureStore();

const AppJsx = (
    <Provider store={store}>
        <AppRouter />
    </Provider>
);
ReactDOM.render(AppJsx, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js